<div
  i18n
  class="w-full h-full flex items-center justify-center font-black text-2xl"
>
  Welcome to TCMR3!
</div>
